import { gql } from "@apollo/client";

export default gql`
	query ($receipt: String!, $lineItemId: Int!) {
		digitalProductAccessLink(receipt: $receipt, lineItemId: $lineItemId)
	}
`;
